export type Region = 'Berlin' | 'Hamburg' | 'Hannover' | 'Nordrhein-Westfalen';

export interface LocationMeta {
  neighborhoods: string[];
  localProblems: string;
  rating: {
    score: number;
    count: number;
  };
  faqs: {
    question: string;
    answer: string;
  }[];
}

export interface Location {
  id: string;
  name: string;
  slug: string;
  region: Region;
  meta: LocationMeta;
}

export const locations: Location[] = [
  // Berlin (12)
  { id: 'b-01', name: 'Mitte', slug: 'mitte', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Mitte treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 299
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Mitte vor Ort?',
        answer: 'Unser lokaler Notdienst in Mitte ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Mitte?',
        answer: 'Wir bieten in ganz Mitte transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Mitte an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Mitte ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-02', name: 'Friedrichshain-Kreuzberg', slug: 'friedrichshain-kreuzberg', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Friedrichshain-Kreuzberg treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 380
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Friedrichshain-Kreuzberg vor Ort?',
        answer: 'Unser lokaler Notdienst in Friedrichshain-Kreuzberg ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Friedrichshain-Kreuzberg?',
        answer: 'Wir bieten in ganz Friedrichshain-Kreuzberg transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Friedrichshain-Kreuzberg an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Friedrichshain-Kreuzberg ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-03', name: 'Pankow', slug: 'pankow', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Pankow treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 310
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Pankow vor Ort?',
        answer: 'Unser lokaler Notdienst in Pankow ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Pankow?',
        answer: 'Wir bieten in ganz Pankow transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Pankow an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Pankow ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-04', name: 'Charlottenburg-Wilmersdorf', slug: 'charlottenburg-wilmersdorf', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Charlottenburg-Wilmersdorf treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 384
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Charlottenburg-Wilmersdorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Charlottenburg-Wilmersdorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Charlottenburg-Wilmersdorf?',
        answer: 'Wir bieten in ganz Charlottenburg-Wilmersdorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Charlottenburg-Wilmersdorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Charlottenburg-Wilmersdorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-05', name: 'Spandau', slug: 'spandau', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Spandau treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 321
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Spandau vor Ort?',
        answer: 'Unser lokaler Notdienst in Spandau ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Spandau?',
        answer: 'Wir bieten in ganz Spandau transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Spandau an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Spandau ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-06', name: 'Steglitz-Zehlendorf', slug: 'steglitz-zehlendorf', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Steglitz-Zehlendorf treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 381
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Steglitz-Zehlendorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Steglitz-Zehlendorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Steglitz-Zehlendorf?',
        answer: 'Wir bieten in ganz Steglitz-Zehlendorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Steglitz-Zehlendorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Steglitz-Zehlendorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-07', name: 'Tempelhof-Schöneberg', slug: 'tempelhof-schoeneberg', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Tempelhof-Schöneberg treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 388
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Tempelhof-Schöneberg vor Ort?',
        answer: 'Unser lokaler Notdienst in Tempelhof-Schöneberg ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Tempelhof-Schöneberg?',
        answer: 'Wir bieten in ganz Tempelhof-Schöneberg transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Tempelhof-Schöneberg an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Tempelhof-Schöneberg ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-08', name: 'Neukölln', slug: 'neukoelln', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Neukölln treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 316
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Neukölln vor Ort?',
        answer: 'Unser lokaler Notdienst in Neukölln ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Neukölln?',
        answer: 'Wir bieten in ganz Neukölln transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Neukölln an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Neukölln ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-09', name: 'Treptow-Köpenick', slug: 'treptow-koepenick', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Treptow-Köpenick treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 368
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Treptow-Köpenick vor Ort?',
        answer: 'Unser lokaler Notdienst in Treptow-Köpenick ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Treptow-Köpenick?',
        answer: 'Wir bieten in ganz Treptow-Köpenick transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Treptow-Köpenick an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Treptow-Köpenick ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-10', name: 'Marzahn-Hellersdorf', slug: 'marzahn-hellersdorf', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Marzahn-Hellersdorf treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 369
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Marzahn-Hellersdorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Marzahn-Hellersdorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Marzahn-Hellersdorf?',
        answer: 'Wir bieten in ganz Marzahn-Hellersdorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Marzahn-Hellersdorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Marzahn-Hellersdorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-11', name: 'Lichtenberg', slug: 'lichtenberg', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Lichtenberg treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 327
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Lichtenberg vor Ort?',
        answer: 'Unser lokaler Notdienst in Lichtenberg ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Lichtenberg?',
        answer: 'Wir bieten in ganz Lichtenberg transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Lichtenberg an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Lichtenberg ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'b-12', name: 'Reinickendorf', slug: 'reinickendorf', region: 'Berlin' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Reinickendorf treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 349
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Reinickendorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Reinickendorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Reinickendorf?',
        answer: 'Wir bieten in ganz Reinickendorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Reinickendorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Reinickendorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },

  // Hamburg (7)
  { id: 'hh-01', name: 'Altona', slug: 'altona', region: 'Hamburg' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Altona treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 280
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Altona vor Ort?',
        answer: 'Unser lokaler Notdienst in Altona ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Altona?',
        answer: 'Wir bieten in ganz Altona transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Altona an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Altona ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'hh-02', name: 'Bergedorf', slug: 'bergedorf', region: 'Hamburg' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Bergedorf treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 297
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Bergedorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Bergedorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Bergedorf?',
        answer: 'Wir bieten in ganz Bergedorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Bergedorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Bergedorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'hh-03', name: 'Eimsbüttel', slug: 'eimsbuettel', region: 'Hamburg' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Eimsbüttel treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 308
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Eimsbüttel vor Ort?',
        answer: 'Unser lokaler Notdienst in Eimsbüttel ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Eimsbüttel?',
        answer: 'Wir bieten in ganz Eimsbüttel transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Eimsbüttel an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Eimsbüttel ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'hh-04', name: 'Hamburg-Mitte', slug: 'hamburg-mitte', region: 'Hamburg' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Hamburg-Mitte treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 329
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Hamburg-Mitte vor Ort?',
        answer: 'Unser lokaler Notdienst in Hamburg-Mitte ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Hamburg-Mitte?',
        answer: 'Wir bieten in ganz Hamburg-Mitte transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Hamburg-Mitte an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Hamburg-Mitte ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'hh-05', name: 'Hamburg-Nord', slug: 'hamburg-nord', region: 'Hamburg' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Hamburg-Nord treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 324
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Hamburg-Nord vor Ort?',
        answer: 'Unser lokaler Notdienst in Hamburg-Nord ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Hamburg-Nord?',
        answer: 'Wir bieten in ganz Hamburg-Nord transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Hamburg-Nord an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Hamburg-Nord ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'hh-06', name: 'Harburg', slug: 'harburg', region: 'Hamburg' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Harburg treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 299
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Harburg vor Ort?',
        answer: 'Unser lokaler Notdienst in Harburg ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Harburg?',
        answer: 'Wir bieten in ganz Harburg transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Harburg an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Harburg ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'hh-07', name: 'Wandsbek', slug: 'wandsbek', region: 'Hamburg' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Wandsbek treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 334
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Wandsbek vor Ort?',
        answer: 'Unser lokaler Notdienst in Wandsbek ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Wandsbek?',
        answer: 'Wir bieten in ganz Wandsbek transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Wandsbek an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Wandsbek ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },

  // Hannover (21)
  { id: 'ha-01', name: 'Hannover', slug: 'hannover', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Hannover treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 304
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Hannover vor Ort?',
        answer: 'Unser lokaler Notdienst in Hannover ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Hannover?',
        answer: 'Wir bieten in ganz Hannover transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Hannover an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Hannover ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-02', name: 'Barsinghausen', slug: 'barsinghausen', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Barsinghausen treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 317
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Barsinghausen vor Ort?',
        answer: 'Unser lokaler Notdienst in Barsinghausen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Barsinghausen?',
        answer: 'Wir bieten in ganz Barsinghausen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Barsinghausen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Barsinghausen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-03', name: 'Burgdorf', slug: 'burgdorf', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Burgdorf treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 292
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Burgdorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Burgdorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Burgdorf?',
        answer: 'Wir bieten in ganz Burgdorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Burgdorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Burgdorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-04', name: 'Burgwedel', slug: 'burgwedel', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Burgwedel treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 297
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Burgwedel vor Ort?',
        answer: 'Unser lokaler Notdienst in Burgwedel ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Burgwedel?',
        answer: 'Wir bieten in ganz Burgwedel transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Burgwedel an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Burgwedel ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-05', name: 'Garbsen', slug: 'garbsen', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Garbsen treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 297
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Garbsen vor Ort?',
        answer: 'Unser lokaler Notdienst in Garbsen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Garbsen?',
        answer: 'Wir bieten in ganz Garbsen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Garbsen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Garbsen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-06', name: 'Gehrden', slug: 'gehrden', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Gehrden treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 297
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Gehrden vor Ort?',
        answer: 'Unser lokaler Notdienst in Gehrden ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Gehrden?',
        answer: 'Wir bieten in ganz Gehrden transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Gehrden an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Gehrden ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-07', name: 'Hemmingen', slug: 'hemmingen', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Hemmingen treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 309
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Hemmingen vor Ort?',
        answer: 'Unser lokaler Notdienst in Hemmingen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Hemmingen?',
        answer: 'Wir bieten in ganz Hemmingen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Hemmingen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Hemmingen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-08', name: 'Isernhagen', slug: 'isernhagen', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Isernhagen treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 316
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Isernhagen vor Ort?',
        answer: 'Unser lokaler Notdienst in Isernhagen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Isernhagen?',
        answer: 'Wir bieten in ganz Isernhagen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Isernhagen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Isernhagen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-09', name: 'Laatzen', slug: 'laatzen', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Laatzen treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 307
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Laatzen vor Ort?',
        answer: 'Unser lokaler Notdienst in Laatzen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Laatzen?',
        answer: 'Wir bieten in ganz Laatzen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Laatzen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Laatzen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-10', name: 'Langenhagen', slug: 'langenhagen', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Langenhagen treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 327
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Langenhagen vor Ort?',
        answer: 'Unser lokaler Notdienst in Langenhagen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Langenhagen?',
        answer: 'Wir bieten in ganz Langenhagen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Langenhagen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Langenhagen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-11', name: 'Lehrte', slug: 'lehrte', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Lehrte treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 302
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Lehrte vor Ort?',
        answer: 'Unser lokaler Notdienst in Lehrte ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Lehrte?',
        answer: 'Wir bieten in ganz Lehrte transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Lehrte an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Lehrte ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-12', name: 'Neustadt am Rübenberge', slug: 'neustadt-am-ruebenberge', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Neustadt am Rübenberge treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 386
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Neustadt am Rübenberge vor Ort?',
        answer: 'Unser lokaler Notdienst in Neustadt am Rübenberge ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Neustadt am Rübenberge?',
        answer: 'Wir bieten in ganz Neustadt am Rübenberge transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Neustadt am Rübenberge an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Neustadt am Rübenberge ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-13', name: 'Pattensen', slug: 'pattensen', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Pattensen treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 325
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Pattensen vor Ort?',
        answer: 'Unser lokaler Notdienst in Pattensen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Pattensen?',
        answer: 'Wir bieten in ganz Pattensen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Pattensen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Pattensen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-14', name: 'Ronnenberg', slug: 'ronnenberg', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Ronnenberg treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 334
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Ronnenberg vor Ort?',
        answer: 'Unser lokaler Notdienst in Ronnenberg ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Ronnenberg?',
        answer: 'Wir bieten in ganz Ronnenberg transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Ronnenberg an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Ronnenberg ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-15', name: 'Seelze', slug: 'seelze', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Seelze treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 316
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Seelze vor Ort?',
        answer: 'Unser lokaler Notdienst in Seelze ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Seelze?',
        answer: 'Wir bieten in ganz Seelze transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Seelze an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Seelze ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-16', name: 'Sehnde', slug: 'sehnde', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Sehnde treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 316
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Sehnde vor Ort?',
        answer: 'Unser lokaler Notdienst in Sehnde ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Sehnde?',
        answer: 'Wir bieten in ganz Sehnde transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Sehnde an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Sehnde ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-17', name: 'Springe', slug: 'springe', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Springe treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 321
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Springe vor Ort?',
        answer: 'Unser lokaler Notdienst in Springe ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Springe?',
        answer: 'Wir bieten in ganz Springe transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Springe an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Springe ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-18', name: 'Uetze', slug: 'uetze', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Uetze treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 315
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Uetze vor Ort?',
        answer: 'Unser lokaler Notdienst in Uetze ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Uetze?',
        answer: 'Wir bieten in ganz Uetze transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Uetze an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Uetze ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-19', name: 'Wedemark', slug: 'wedemark', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Wedemark treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 334
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Wedemark vor Ort?',
        answer: 'Unser lokaler Notdienst in Wedemark ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Wedemark?',
        answer: 'Wir bieten in ganz Wedemark transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Wedemark an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Wedemark ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-20', name: 'Wennigsen (Deister)', slug: 'wennigsen-deister', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Wennigsen (Deister) treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 389
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Wennigsen (Deister) vor Ort?',
        answer: 'Unser lokaler Notdienst in Wennigsen (Deister) ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Wennigsen (Deister)?',
        answer: 'Wir bieten in ganz Wennigsen (Deister) transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Wennigsen (Deister) an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Wennigsen (Deister) ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'ha-21', name: 'Wunstorf', slug: 'wunstorf', region: 'Hannover' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Wunstorf treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 334
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Wunstorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Wunstorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Wunstorf?',
        answer: 'Wir bieten in ganz Wunstorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Wunstorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Wunstorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },

  // Nordrhein-Westfalen
  { id: 'nw-01', name: 'Arnsberg', slug: 'arnsberg', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Arnsberg treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 290
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Arnsberg vor Ort?',
        answer: 'Unser lokaler Notdienst in Arnsberg ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Arnsberg?',
        answer: 'Wir bieten in ganz Arnsberg transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Arnsberg an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Arnsberg ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-02', name: 'Detmold', slug: 'detmold', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Detmold treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 291
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Detmold vor Ort?',
        answer: 'Unser lokaler Notdienst in Detmold ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Detmold?',
        answer: 'Wir bieten in ganz Detmold transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Detmold an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Detmold ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-03', name: 'Düsseldorf', slug: 'duesseldorf', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Düsseldorf treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 306
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Düsseldorf vor Ort?',
        answer: 'Unser lokaler Notdienst in Düsseldorf ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Düsseldorf?',
        answer: 'Wir bieten in ganz Düsseldorf transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Düsseldorf an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Düsseldorf ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-04', name: 'Köln', slug: 'koeln', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Köln treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 290
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Köln vor Ort?',
        answer: 'Unser lokaler Notdienst in Köln ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Köln?',
        answer: 'Wir bieten in ganz Köln transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Köln an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Köln ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-05', name: 'Münster', slug: 'muenster', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Münster treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 309
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Münster vor Ort?',
        answer: 'Unser lokaler Notdienst in Münster ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Münster?',
        answer: 'Wir bieten in ganz Münster transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Münster an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Münster ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-06', name: 'Dortmund', slug: 'dortmund', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Dortmund treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 296
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Dortmund vor Ort?',
        answer: 'Unser lokaler Notdienst in Dortmund ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Dortmund?',
        answer: 'Wir bieten in ganz Dortmund transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Dortmund an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Dortmund ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-07', name: 'Essen', slug: 'essen', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Essen treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 283
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Essen vor Ort?',
        answer: 'Unser lokaler Notdienst in Essen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Essen?',
        answer: 'Wir bieten in ganz Essen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Essen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Essen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-08', name: 'Duisburg', slug: 'duisburg', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Duisburg treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 296
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Duisburg vor Ort?',
        answer: 'Unser lokaler Notdienst in Duisburg ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Duisburg?',
        answer: 'Wir bieten in ganz Duisburg transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Duisburg an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Duisburg ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-09', name: 'Bochum', slug: 'bochum', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Bochum treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 282
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Bochum vor Ort?',
        answer: 'Unser lokaler Notdienst in Bochum ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Bochum?',
        answer: 'Wir bieten in ganz Bochum transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Bochum an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Bochum ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-10', name: 'Bonn', slug: 'bonn', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Bonn treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 272
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Bonn vor Ort?',
        answer: 'Unser lokaler Notdienst in Bonn ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Bonn?',
        answer: 'Wir bieten in ganz Bonn transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Bonn an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Bonn ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-11', name: 'Wuppertal', slug: 'wuppertal', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Wuppertal treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 339
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Wuppertal vor Ort?',
        answer: 'Unser lokaler Notdienst in Wuppertal ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Wuppertal?',
        answer: 'Wir bieten in ganz Wuppertal transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Wuppertal an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Wuppertal ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-12', name: 'Bielefeld', slug: 'bielefeld', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Bielefeld treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 297
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Bielefeld vor Ort?',
        answer: 'Unser lokaler Notdienst in Bielefeld ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Bielefeld?',
        answer: 'Wir bieten in ganz Bielefeld transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Bielefeld an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Bielefeld ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-13', name: 'Gelsenkirchen', slug: 'gelsenkirchen', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Gelsenkirchen treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 327
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Gelsenkirchen vor Ort?',
        answer: 'Unser lokaler Notdienst in Gelsenkirchen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Gelsenkirchen?',
        answer: 'Wir bieten in ganz Gelsenkirchen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Gelsenkirchen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Gelsenkirchen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-14', name: 'Aachen', slug: 'aachen', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Aachen treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 280
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Aachen vor Ort?',
        answer: 'Unser lokaler Notdienst in Aachen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Aachen?',
        answer: 'Wir bieten in ganz Aachen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Aachen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Aachen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-15', name: 'Krefeld', slug: 'krefeld', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Krefeld treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 305
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Krefeld vor Ort?',
        answer: 'Unser lokaler Notdienst in Krefeld ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Krefeld?',
        answer: 'Wir bieten in ganz Krefeld transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Krefeld an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Krefeld ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-16', name: 'Oberhausen', slug: 'oberhausen', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Oberhausen treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 328
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Oberhausen vor Ort?',
        answer: 'Unser lokaler Notdienst in Oberhausen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Oberhausen?',
        answer: 'Wir bieten in ganz Oberhausen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Oberhausen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Oberhausen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-17', name: 'Hagen', slug: 'hagen', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Hagen treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 289
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Hagen vor Ort?',
        answer: 'Unser lokaler Notdienst in Hagen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Hagen?',
        answer: 'Wir bieten in ganz Hagen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Hagen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Hagen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-18', name: 'Hamm', slug: 'hamm', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Hamm treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 284
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Hamm vor Ort?',
        answer: 'Unser lokaler Notdienst in Hamm ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Hamm?',
        answer: 'Wir bieten in ganz Hamm transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Hamm an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Hamm ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-19', name: 'Herne', slug: 'herne', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Herne treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 289
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Herne vor Ort?',
        answer: 'Unser lokaler Notdienst in Herne ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Herne?',
        answer: 'Wir bieten in ganz Herne transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Herne an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Herne ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-20', name: 'Leverkusen', slug: 'leverkusen', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Leverkusen treten besonders häufig Verstopfte Abflüsse durch Fettablagerungen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 322
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Leverkusen vor Ort?',
        answer: 'Unser lokaler Notdienst in Leverkusen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Leverkusen?',
        answer: 'Wir bieten in ganz Leverkusen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Leverkusen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Leverkusen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-21', name: 'Mönchengladbach', slug: 'moenchengladbach', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Mönchengladbach treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 349
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Mönchengladbach vor Ort?',
        answer: 'Unser lokaler Notdienst in Mönchengladbach ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Mönchengladbach?',
        answer: 'Wir bieten in ganz Mönchengladbach transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Mönchengladbach an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Mönchengladbach ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-22', name: 'Mülheim an der Ruhr', slug: 'muelheim-an-der-ruhr', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Mülheim an der Ruhr treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 369
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Mülheim an der Ruhr vor Ort?',
        answer: 'Unser lokaler Notdienst in Mülheim an der Ruhr ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Mülheim an der Ruhr?',
        answer: 'Wir bieten in ganz Mülheim an der Ruhr transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Mülheim an der Ruhr an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Mülheim an der Ruhr ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-23', name: 'Solingen', slug: 'solingen', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Solingen treten besonders häufig Verkalkte Rohre in Altbauten auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.9,
      count: 326
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Solingen vor Ort?',
        answer: 'Unser lokaler Notdienst in Solingen ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Solingen?',
        answer: 'Wir bieten in ganz Solingen transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Solingen an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Solingen ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-24', name: 'Remscheid', slug: 'remscheid', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Remscheid treten besonders häufig Wurzeleinwuchs in Kanalsystemen auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.7,
      count: 329
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Remscheid vor Ort?',
        answer: 'Unser lokaler Notdienst in Remscheid ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Remscheid?',
        answer: 'Wir bieten in ganz Remscheid transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Remscheid an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Remscheid ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } },
  { id: 'nw-25', name: 'Bottrop', slug: 'bottrop', region: 'Nordrhein-Westfalen' , meta: {
    neighborhoods: ['Zentrum', 'Nord', 'Süd', 'West', 'Ost'],
    localProblems: 'In Bottrop treten besonders häufig Veraltete Fallrohre und Leitungssysteme auf. Unsere lokalen Monteure kennen die spezifischen infrastrukturellen Herausforderungen der Stadt genau.',
    rating: {
      score: 4.8,
      count: 287
    },
    faqs: [
      {
        question: 'Wie schnell ist der Notdienst in Bottrop vor Ort?',
        answer: 'Unser lokaler Notdienst in Bottrop ist in der Regel innerhalb von 30 bis 60 Minuten bei Ihnen vor Ort, unabhängig vom Stadtteil.'
      },
      {
        question: 'Was kostet eine Rohrreinigung in Bottrop?',
        answer: 'Wir bieten in ganz Bottrop transparente Festpreise. Eine einfache Rohrreinigung beginnt bei unseren günstigen Pauschalpreisen. Kontaktieren Sie uns für ein exaktes Angebot für Ihr Problem.'
      },
      {
        question: 'Bieten Sie auch am Wochenende Notdienst in Bottrop an?',
        answer: 'Ja, unser Rohrreinigungs-Notdienst in Bottrop ist 24 Stunden am Tag, 7 Tage die Woche, auch an Sonn- und Feiertagen für Sie im Einsatz.'
      }
    ]
  } }
];
